import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
//import { doc, setDoc, updateDoc, increment } from "firebase/firestore";
//import { db } from "./Firebase";
import styled from "styled-components";
import { Alert, CloseButton } from './App';
import { MdStart } from "react-icons/md";

const ContenedorForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 240px;
  & label{
    font-size: small;
  }
`;
const Input = styled.input`
    border: none;
    background-color: #ebe5e5;
    border-radius: 3px;
    border-bottom: solid 1px #c20000;
    width: 90%;
    margin: 0px;
    &:focus {
      outline: none;
    }
`;
const EstiloButton = styled.button`
  margin-top: 0.5rem;
  background-color: transparent;
  color: white;
  border: none;
  &:hover {
    color: grey;
    transition: 0.3s;
  }
`;

const IniciarSesion = ({ onUserChange }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const closeAlert = () => {
    setShowAlert(false);
  };

  async function handleSignIn(e) {
    e.preventDefault();

    try {
      const auth = getAuth(); // Obtener la instancia de autenticación
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      // Si la autenticación es exitosa, userCredential.user contendrá el usuario autenticado.
      const user = userCredential.user;

      //Actualizar el estado del usuario a "online" e incrementar el contador de conexiones
      //const userDocRef = doc(db, "users", user.uid);
      //await setDoc(userDocRef, { state: "online" }, { merge: true });
      //await updateDoc(userDocRef, { connections: increment(1) });

      onUserChange(user);
    } catch (error) {
      setShowAlert(true);
      // Manejar el error aquí, por ejemplo, mostrar un mensaje de error al usuario.
    }
  }

  return (
    <div>
      {showAlert && (
        <Alert>
        <CloseButton onClick={closeAlert}>&times;</CloseButton>
        Acceso inválido. Revise correo o contraseña.
        </Alert>
      )}
      <ContenedorForm onSubmit={handleSignIn}>
        <Input
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label>Correo electrónico</label>
        <Input
            type="password"
            name="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
         <label>Contraseña</label>
          <EstiloButton type="submit">
             <MdStart size={30} style={{color: "#565656"}}/>
          </EstiloButton>
      </ContenedorForm>
    </div>
  );
};

export default IniciarSesion;
